import { render, staticRenderFns } from "./side-by-side-cmp.vue?vue&type=template&id=4f356b48&scoped=true"
import script from "./side-by-side-cmp.vue?vue&type=script&lang=js"
export * from "./side-by-side-cmp.vue?vue&type=script&lang=js"
import style0 from "./side-by-side-cmp.vue?vue&type=style&index=0&id=4f356b48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f356b48",
  null
  
)

export default component.exports